
const createId = (() => {
  let n = 0;
  return (prefix) => `${prefix}-${++n}`;
})();

function toIndustryLabel(option) {
  if (typeof option === "string") return option;
  return option?.description || option?.code || "";
}

export { createId, toIndustryLabel };
